<div class="sw-field">
    <div style="font-size: 14px; margin-bottom: 10px;">{{ $tc('reci-config.button.hint') }}</div>
    <mt-button @click="onClick" variant="primary">
        <span class="sw-button__content">
                {{ $tc('reci-config.button.label') }}
        </span>
        <mt-loader v-if="isLoading" />
    </mt-button>
</div>
